module.exports = __webpack_public_path__ + "ci_vendor_zabbix.bc0dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_zabbix.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_zabbix.svg
// module chunks = main